module.exports = __webpack_public_path__ + "static/media/delete_icon_benef.5a652ffe.svg";